import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=66d8a7b2&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.scss?vue&type=style&index=0&id=66d8a7b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8a7b2",
  null
  
)

export default component.exports